// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bank-account-select-select_container-mpVx2 {
  width: 100%;
  margin-top: 24px;
}

.bank-account-select-select_popup-gGNI6 {
  padding: 8px 0px;
  max-height: 220px;
  overflow: auto;
}

.bank-account-select-selectOption_container-d48Sk {
  padding: 0px;
}
`, "",{"version":3,"sources":["webpack://./src/components/bank-account-select/bank-account-select.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,YAAY;AACd","sourcesContent":[".select_container {\n  width: 100%;\n  margin-top: 24px;\n}\n\n.select_popup {\n  padding: 8px 0px;\n  max-height: 220px;\n  overflow: auto;\n}\n\n.selectOption_container {\n  padding: 0px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"select_container": `bank-account-select-select_container-mpVx2`,
	"select_popup": `bank-account-select-select_popup-gGNI6`,
	"selectOption_container": `bank-account-select-selectOption_container-d48Sk`
};
export default ___CSS_LOADER_EXPORT___;
